// extracted by mini-css-extract-plugin
export default {"container":"RoundRobinStandings_container__NIq3l","title":"RoundRobinStandings_title__2Y9x8","table":"RoundRobinStandings_table__ab6oY"};